document.querySelectorAll('[data-language-selector]').forEach((selector) => {
  selector.addEventListener('click', (event) => {
    const clickEventPath = event.composedPath().slice(0, -2);

    for (const element of clickEventPath) {
      const clickAction = element?.getAttribute('data-action');
      if (!clickAction) continue;

      if (clickAction === 'switch-language') {
        event.preventDefault();
        switchLanguageHandler(element);
        break;
      }
    }
  });
});

/**
 *  Handles the language switch when a language button is clicked.
 * @param {HTMLElement} languageButton The button element that was clicked.
 */
function switchLanguageHandler(languageButton) {
  if (Object.hasOwn(languageButton.parentElement.dataset, 'active')) return;

  const languageCode = languageButton.getAttribute('lang');

  const languageForm = languageButton.closest('form');

  languageForm.querySelector('input[name="language_code"]').value = languageCode;
  languageForm.submit();
}

(function () {
  const DEFAULT_SWITCH_DELAY = 5000;
  let carouselInterval;

  /**
   * Initializes the announcement bar when the DOM is fully loaded.
   */
  function initAnnouncementBar() {
    const announcementBar = document.querySelector('.mx-announcement-bar');
    if (!announcementBar) return;

    const announcements = announcementBar.querySelector('.announcement-list');
    if (!announcements) return;

    const switchDelay = Number.parseInt(announcements.dataset.switchDelay ?? DEFAULT_SWITCH_DELAY);

    announcementBar.addEventListener('mouseenter', stopCarousel);
    announcementBar.addEventListener('mouseleave', () => {
      startCarousel(announcements, switchDelay);
    });

    startCarousel(announcements, switchDelay);
  }

  /**
   * Switches the announcement in the carousel.
   * @param {HTMLElement} announcements The container element for the announcements.
   * @param {number} switchDelay The delay in milliseconds between each announcement switch.
   */
  function switchAnnouncement(announcements, switchDelay) {
    const firstAnnouncement = announcements.firstElementChild;
    const announcementWidth = firstAnnouncement.offsetWidth;

    announcements.scrollBy({ left: announcementWidth, behavior: 'smooth' });

    setTimeout(() => {
      announcements.append(firstAnnouncement.cloneNode(true));
      firstAnnouncement.remove();

      announcements.scroll({ left: 0 });
    }, switchDelay / 2);
  }

  /**
   * Starts the carousel to switch announcements at a specified interval.
   * @param {HTMLElement} announcements The container element for the announcements.
   * @param {number} switchDelay The delay in milliseconds between each announcement switch.
   */
  function startCarousel(announcements, switchDelay) {
    carouselInterval = setInterval(() => {
      switchAnnouncement(announcements, switchDelay);
    }, switchDelay);
  }

  /**
   * Stops the carousel from switching announcements.
   */
  function stopCarousel() {
    clearInterval(carouselInterval);
  }

  // Initialize the announcement bar when the DOM is fully loaded
  initAnnouncementBar();
})();
